common.View.create('canvas.blocks.custom.videoSlider.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            loop: true,
            margin: 50,
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            navText : ["<i class='fal fa-angle-left'></i>","<i class='fal fa-angle-right'></i>"],
            dots: false,
            autoplay: false,
            mouseDrag: false,
            responsive: {
                0: {
                    items: 1
                },
                640: {
                    items: 2,
                },
                1000: {
                    items: 3,
                }
            }
        });
    },

});
